module.exports = __webpack_public_path__ + "static/img/Kayal-Iro.d9f690a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kayal-Iro.jpg
// module id = SmPB
// module chunks = 0